var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCaretLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 200 352",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92226e-05 175.743C-0.00407676 172.558 0.621468 169.403 1.84069 166.459C3.0599 163.516 4.84877 160.843 7.10446 158.593L158.613 7.08446C163.164 2.54454 169.33 -0.00351849 175.758 3.64659e-06C182.186 0.00352578 188.349 2.55834 192.895 7.10324C197.44 11.6481 199.996 17.8114 200 24.2393C200.004 30.6671 197.457 36.8338 192.918 41.3847L58.5608 175.743L192.918 310.102C197.457 314.653 200.004 320.82 200 327.248C199.996 333.675 197.44 339.839 192.895 344.384C188.349 348.929 182.186 351.483 175.758 351.487C169.33 351.49 163.164 348.942 158.613 344.402L7.10446 192.894C4.84877 190.644 3.0599 187.971 1.84069 185.028C0.621468 182.084 -0.00407676 178.929 1.92226e-05 175.743Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaretLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CaretLeft.c6d3ba93.svg";
export { ForwardRef as ReactComponent };